



























// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import apiForfait from '@/api/forfait'
import { toSubArray } from '@/utils/groupBy'
import ReadContent from '@/components/administration/forfait/read/ReadContent.vue'
import ReadActivity from '@/components/administration/forfait/read/ReadActivity.vue'
import ReadPiscine from '@/components/administration/forfait/read/ReadPiscine.vue'
import { AloForfait, getDefaultAloForfait } from '@/models/alo/AloForfait'
import { directPayloadQuery } from '@/utils/api'
import {DashboardAdmin} from '@/router/pages'


@Component({
  name: 'ModifyForfait', 
  props: {
    forfaitId:Number
  },
  components: { ReadContent, ReadActivity,ReadPiscine },
})

export default class ModifyForfait extends Vue {
  forfaitId!: number
  private showError = false    
  private rightDrawer = false
  private loading = false
  private saving = false

  get forfait(){
    return this.$store.myGetters.forfaitDic[this.forfaitId] || getDefaultAloForfait()
  }

/*
  get defaultCrops(){
    return this.$store.myGetters.configuration.forfait.crops
  }
  get maxImages(){
    return this.$store.myGetters.configuration.forfait.maxImages
  }*/

  loadForfait() {    
    this.loading = true    
    this.$store.myActions.ADM_FORFAIT_DETAIL_REQUEST(this.forfaitId).finally(() => {      
      this.loading = false
    })    
  }

  created(){
    this.$store.myActions.ADM_ACTIVITY_ENSURE();
    this.loadForfait()
  }  

  get arianeItems() {
    const arianeItems =  [
        DashboardAdmin,
        {
          text: 'Forfait',
          disabled: false,  
          to: {name:'AdminForfait'},        
          exact:true
        }
      ]
    if(this.forfait) {
        arianeItems.push({
          text: this.forfait.libelle,
          disabled: true,             
          to: {name:''},                         
          exact:true
        })
    }
    return arianeItems;
  } 
/*
  onOrderChange(temPhotosIds:string) {
   this.saveImages(temPhotosIds,"Modification de l'ordre des images sauvegardé")
  }

  onImageAdded(temPhotosIds:string){
    this.saveImages(temPhotosIds,"Ajout image(s) sauvegardé")
  }

  onImageDeleted(temPhotosIds:string){
    this.saveImages(temPhotosIds,"Image supprimée")
  }  
  
  saveImages(temPhotosIds:string,message:string){
    this.saving = true
    const temUplPhoto = (temPhotosIds && temPhotosIds.length>0)?parseInt(temPhotosIds.split(',')[0]):0
    const modified = {...this.forfait,temPhotosIds,temUplPhoto}
    this.$store.myActions.ADM_FORFAIT_SAVE_REQUEST(modified).then(() => {
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(message)                  
      }).finally(() => {
        this.saving = false
      })
  }
*/

}
